import React from 'react'
import type { PresentationBlockProps } from '../../'
import compareBlockProps from '../../util/compareBlockProps'
import QuoteTerms from '../../../Quote/QuoteTerms'
import TermsPlaceholder from './TermsPlaceholder'
import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import classnames from 'classnames'
import { useFlags } from 'shared/components/common/FlagsProvider'

const useStyles = makeStyles(
  (theme: Theme) => ({
    quotePaper: {
      // sames styles as $paper in Quote
      background: theme.palette.common.white,
      border: `1px solid #888`,
      borderRadius: theme.borderRadius.md,
      boxShadow: 'none',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 0,
      padding: theme.spacing(8),
      position: 'relative',
      width: '100%',
      [theme.breakpoints.down('md')]: {
        width: '100%'
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(3),
        width: '100%'
      },
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(3, 2),
        marginBottom: 0
      },
      // Fallthrough for the redesigned document (estimateNext): it renders its own card chrome
      // (`QuoteNextView`'s `documentCard` — 1px P85, `borderRadius.lg`) instead of the legacy Paper
      // this box was matched to, so match that one instead (ENG-1479).
      '&$quotePaperNext': {
        border: `1px solid ${theme.paintscout.palette.brand.Neutral.P85}`,
        borderRadius: theme.borderRadius.lg
      }
    },
    // Marker class for the rule above — carries no styles of its own.
    quotePaperNext: {}
  }),
  { name: 'TermsBlock' }
)

function TermsBlock(props: PresentationBlockProps) {
  const classes = useStyles(props)
  const { WrapperComponent, isSettings, isInvoice } = props
  const estimateNext = !!useFlags().estimateNext

  return (
    <WrapperComponent {...props}>
      {isSettings ? (
        <TermsPlaceholder />
      ) : (
        <div
          className={isInvoice ? classnames(classes.quotePaper, { [classes.quotePaperNext]: estimateNext }) : undefined}
        >
          <QuoteTerms />
        </div>
      )}
    </WrapperComponent>
  )
}

export default React.memo(TermsBlock, (prevProps, nextProps) => {
  return compareBlockProps(prevProps, nextProps)
})
